module.exports = __webpack_public_path__ + "img/1444464816.ead01540.jpg";